import request from '@/utils/request';

export const FETCH_WALLET_BALANCE_REQUEST = 'FETCH_WALLET_BALANCE_REQUEST';
export const FETCH_WALLET_BALANCE_SUCCESS = 'FETCH_WALLET_BALANCE_SUCCESS';
export const FETCH_WALLET_BALANCE_FAILURE = 'FETCH_WALLET_BALANCE_FAILURE';

export const TOP_UP_WALLET_REQUEST = 'TOP_UP_WALLET_REQUEST';
export const TOP_UP_WALLET_SUCCESS = 'TOP_UP_WALLET_SUCCESS';
export const TOP_UP_WALLET_FAILURE = 'TOP_UP_WALLET_FAILURE';

export const UPDATE_AUTO_REFILL_SETTINGS_REQUEST = 'UPDATE_AUTO_REFILL_SETTINGS_REQUEST';
export const UPDATE_AUTO_REFILL_SETTINGS_SUCCESS = 'UPDATE_AUTO_REFILL_SETTINGS_SUCCESS';
export const UPDATE_AUTO_REFILL_SETTINGS_FAILURE = 'UPDATE_AUTO_REFILL_SETTINGS_FAILURE';

export const FETCH_WALLET_TRANSACTIONS_REQUEST = 'FETCH_WALLET_TRANSACTIONS_REQUEST';
export const FETCH_WALLET_TRANSACTIONS_SUCCESS = 'FETCH_WALLET_TRANSACTIONS_SUCCESS';
export const FETCH_WALLET_TRANSACTIONS_FAILURE = 'FETCH_WALLET_TRANSACTIONS_FAILURE';

export const ESTIMATE_USAGE_COST_REQUEST = 'ESTIMATE_USAGE_COST_REQUEST';
export const ESTIMATE_USAGE_COST_SUCCESS = 'ESTIMATE_USAGE_COST_SUCCESS';
export const ESTIMATE_USAGE_COST_FAILURE = 'ESTIMATE_USAGE_COST_FAILURE';

export const FETCH_WALLET_ANALYTICS_REQUEST = 'FETCH_WALLET_ANALYTICS_REQUEST';
export const FETCH_WALLET_ANALYTICS_SUCCESS = 'FETCH_WALLET_ANALYTICS_SUCCESS';
export const FETCH_WALLET_ANALYTICS_FAILURE = 'FETCH_WALLET_ANALYTICS_FAILURE';

export const WALLET_INVOICES = 'WALLET_INVOICES';
export const WALLET_INVOICE = 'WALLET_INVOICE';

export const fetchWalletBalance = () => async dispatch => {
  dispatch({ type: FETCH_WALLET_BALANCE_REQUEST });
  try {
    const response = await request({
      path: '/v1/wallets'
    });
    dispatch({ type: FETCH_WALLET_BALANCE_SUCCESS, payload: response });
  } catch (error) {
    dispatch({ type: FETCH_WALLET_BALANCE_FAILURE, payload: error.message });
  }
};

export const topUpWallet = (amount, description) => async dispatch => {
  dispatch({ type: TOP_UP_WALLET_REQUEST });
  try {
    const response = await request({
      path: '/v1/wallets/top_up',
      method: 'POST',
      body: { amount, description }
    });
    dispatch({ type: TOP_UP_WALLET_SUCCESS, payload: response });
    dispatch(fetchWalletBalance());
  } catch (error) {
    dispatch({ type: TOP_UP_WALLET_FAILURE, payload: error.message });
  }
};

export const updateAutoRefillSettings = settings => async dispatch => {
  dispatch({ type: UPDATE_AUTO_REFILL_SETTINGS_REQUEST });
  try {
    const response = await request({
      path: '/v1/wallets/update_settings',
      method: 'PUT',
      body: settings
    });
    dispatch({ type: UPDATE_AUTO_REFILL_SETTINGS_SUCCESS, payload: response });
  } catch (error) {
    dispatch({ type: UPDATE_AUTO_REFILL_SETTINGS_FAILURE, payload: error.message });
  }
};

export const fetchWalletTransactions = (page, pageSize, filter) => async dispatch => {
  dispatch({ type: FETCH_WALLET_TRANSACTIONS_REQUEST });
  try {
    const query = { page, per_page: pageSize };
    if (filter && filter !== 'all') {
      query.filter = filter;
    }
    const response = await request({
      path: '/v1/wallets/transaction_history',
      query
    });
    dispatch({ type: FETCH_WALLET_TRANSACTIONS_SUCCESS, payload: response });
  } catch (error) {
    dispatch({ type: FETCH_WALLET_TRANSACTIONS_FAILURE, payload: error.message });
  }
};

export const estimateUsageCost = (usageType, quantity) => async dispatch => {
  dispatch({ type: ESTIMATE_USAGE_COST_REQUEST });
  try {
    const response = await request({
      path: '/v1/wallets/estimate_cost',
      method: 'POST',
      body: { usageType, quantity }
    });
    dispatch({ type: ESTIMATE_USAGE_COST_SUCCESS, payload: { usageType, data: response } });
  } catch (error) {
    dispatch({ type: ESTIMATE_USAGE_COST_FAILURE, payload: error.message });
  }
};

export const fetchWalletAnalytics = (period, corporationId) => async dispatch => {
  dispatch({ type: FETCH_WALLET_ANALYTICS_REQUEST });
  try {
    const response = await request({
      path: '/v1/wallets/analytics',
      query: { period, ...(corporationId && { corporation_id: corporationId }) }
    });
    dispatch({ type: FETCH_WALLET_ANALYTICS_SUCCESS, payload: response });
  } catch (error) {
    dispatch({ type: FETCH_WALLET_ANALYTICS_FAILURE, payload: error.message });
  }
};

export const fetchWalletInvoices =
  (query = {}) =>
  async dispatch => {
    const response = await request({
      path: `/v1/wallets/invoice_history`,
      query
    });
    dispatch({
      payload: response,
      type: WALLET_INVOICES
    });
  };

export const fetchWalletInvoice =
  (query = {}) =>
  async dispatch => {
    const response = await request({
      path: `/v1/wallets/invoice`,
      query
    });
    dispatch({
      payload: response,
      type: WALLET_INVOICE
    });
  };

export const reclaimWallet = userIds => async () => {
  const response = await request({
    path: `/v1/wallets/reclaim`,
    method: 'POST',
    body: { user_ids: userIds }
  });
  return response;
};

export const allocateWallet = (userIds, amount) => async () => {
  const response = await request({
    path: `/v1/wallets/allocate`,
    method: 'POST',
    body: { user_ids: userIds, amount: Number(amount) }
  });
  return response;
};

export const fetchUsagePricing = () => async () =>
  await request({
    path: '/v1/wallets/usage_pricing'
  });
